import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  getSKUWithoutPrefix,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
} from './shared.mjs'

import { lenses, reflection, iris } from './forty2s.mjs'

export const ghost = {
  id: 'ghost',
  name: 'Ghost Frame',
  hasOptions: false,
  imgproxySettings,
  mobileImgproxySettings,
  opacity: 0.5,
  pathTemplate: 'gs://sg360/250502/forty2slrk/{nnn}-ghost.png',
}

function resolveOptions(customisedProduct) {
  return {
    lens: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    iris: 'mask',
    reflections: 'none',
  }
}

export default {
  layers: [background, ghost, lenses, iris, reflection],
  resolveOptions,
  resolveOptionsFromSKU,
}
